var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-row-center-center w-100",staticStyle:{"min-height":"200px"}},[_c('div',{staticClass:"text-caption tableText--text"},[_vm._v(" "+_vm._s(_vm.$t("noData"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }